export default "__VITE_ASSET__BoLTHX6n__"